var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex overflow-hidden justify-center bg-brand-secondary h-2_75 header-top"
    },
    [
      _c("div", { staticClass: "flex justify-between h-full container px-1" }, [
        _c("div", { staticClass: "flex items-center" }),
        _c(
          "div",
          { staticClass: "flex text-white items-center text-sm" },
          [
            _c(
              "div",
              {
                staticClass: "text-md mr-2 cursor-pointer",
                attrs: { tabindex: "0" },
                on: {
                  click: function($event) {
                    return _vm.$emit("navigate", "help")
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.$emit("navigate", "help")
                  }
                }
              },
              [_vm._v("Help")]
            ),
            _c(
              "router-link",
              {
                staticClass: "text-md mr-2 cursor-pointer",
                attrs: { tabindex: "0", tag: "div", to: { name: "trackOrder" } }
              },
              [_vm._v("Track Order")]
            ),
            _vm.userLoggedIn
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "text-md mr-2 cursor-pointer",
                      attrs: { tabindex: "0" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("navigate", "dashboard")
                        },
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.$emit("navigate", "dashboard")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.dashboardLabel))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-md cursor-pointer",
                      attrs: { tabindex: "0" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("log-out")
                        },
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.$emit("log-out")
                        }
                      }
                    },
                    [_vm._v("Sign Out")]
                  )
                ]
              : _c(
                  "router-link",
                  {
                    staticClass: "text-md cursor-pointer",
                    attrs: { tabindex: "0", tag: "div", to: { name: "signIn" } }
                  },
                  [_vm._v("Sign In")]
                )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }